import type { DataTableHeader } from 'vuetify';
import { platformDictionary } from '@/stores';
import i18n from '@/plugins/i18n';

interface CurrencyDictionary {
    itemById: (id: number) => { symbol: string };
}

export function createTurnoverSelectionPageHeaders(currencyDictionary: CurrencyDictionary, displayedCurrencyId: number): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: '',
            key: 'data-table-expand',
            value: 'data-table-expand',
            align: 'center',
            sortable: false,
            minWidth: 28,
            width: 28,
            cellProps: { class: 'px-0' },
        },
        {
            title: t('turnoverSelection.date'),
            value: 'date',
            key: 'date',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverSelection.league'),
            value: 'customLeagueName',
            key: 'customLeagueName',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('turnoverSelection.limitCategory'),
            value: 'customLeagueLimitsCategoryId',
            key: 'customLeagueLimitsCategoryId',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverSelection.home'),
            value: 'customTeamHomeName',
            key: 'customTeamHomeName',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('turnoverSelection.away'),
            value: 'customTeamAwayName',
            key: 'customTeamAwayName',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('turnoverSelection.period'),
            value: 'periodTypeId',
            key: 'periodTypeId',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverSelection.selection'),
            value: 'selectionId',
            key: 'selectionId',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverSelection.handicap'),
            value: 'handicap',
            key: 'handicap',
            align: 'center',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverSelection.bets'),
            value: 'betCount',
            key: 'betCount',
            align: 'center',
            sortable: true,
            nowrap: true,
        },
        {
            title: currencyDictionary.itemById(displayedCurrencyId).symbol + ' ' + t('turnoverSelection.stake'),
            value: 'stakeSum',
            key: 'stakeSum',
            align: 'center',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverSelection.oddsAvg'),
            value: 'oddsAvg',
            key: 'oddsAvg',
            align: 'center',
            sortable: true,
            nowrap: true,
        },
        {
            title: currencyDictionary.itemById(displayedCurrencyId).symbol + ' ' + t('turnoverSelection.netPayout'),
            value: 'netPayoutSum',
            key: 'netPayoutSum',
            align: 'center',
            sortable: true,
            nowrap: true,
        },
        {
            title: currencyDictionary.itemById(displayedCurrencyId).symbol + ' ' + t('turnoverSelection.pl'),
            value: 'balance',
            key: 'balance',
            align: 'center',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverSelection.users'),
            value: 'userCount',
            key: 'userCount',
            align: 'center',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverSelection.unsettledBets'),
            value: 'unsettledBetCount',
            key: 'unsettledBetCount',
            align: 'center',
            sortable: true,
            nowrap: true,
        },
        {
            title: '',
            value: 'actions',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 24,
            cellProps: { class: 'pl-0 pr-1' },
        },
    ];
}

export function createTurnoverSelectionDetailHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: t('bets.platform'),
            key: 'platform',
            value: (row: any) => platformDictionary.nameById(row.platform_id) || String(row.platform_id),
            sortable: true,
            nowrap: true,
            align: 'start',
        },
        { title: t('turnoverSelection.bets'), key: 'betCount', value: (row: any) => row.bet_count, sortable: true, nowrap: true, align: 'center' },
        { title: t('turnoverSelection.stake'), key: 'stakeSum', value: (row: any) => row.stake_sum, sortable: true, nowrap: true, align: 'center' },
        { title: t('turnoverSelection.oddsAvg'), key: 'oddsAvg', value: (row: any) => row.odds_avg, sortable: true, nowrap: true, align: 'center' },
        {
            title: t('turnoverSelection.netPayout'),
            key: 'netPayoutSum',
            value: (row: any) => row.net_payout_sum,
            sortable: true,
            nowrap: true,
            align: 'center',
        },
        { title: t('turnoverSelection.pl'), key: 'balance', value: (row: any) => row.balance, sortable: true, nowrap: true, align: 'center' },
        { title: t('turnoverSelection.users'), key: 'userCount', value: (row: any) => row.user_count, sortable: true, nowrap: true, align: 'center' },
        {
            title: t('turnoverSelection.unsettledBets'),
            key: 'unsettledBetCount',
            value: (row: any) => row.unsettled_bet_count,
            sortable: true,
            nowrap: true,
            align: 'center',
        },
    ];
}
